import React from 'react'
import whychooseimage from "../../Assests/AboutUs/whychooseimage.png"

function WhyChooseVizzhy() {
  return (
    <div className='WhyChooseVizzhy '>
        <div className='row w-100 pt-5 justify-content-center'>
        <div className='col-md-4'>
        <div className='d-flex justify-content-center align-items-center pt-5 mt-5'> 
            <img src={whychooseimage} style={{width:"85%"}} alt='whychooseimage'/>
        </div>
        </div>
        <div className='col-md-7 d-flex justify-content-center mission-vison-content p-5 mb-5'>
            <div className=''>
            <div className=' fw-bold missionandvisiontextcolor mission-vison-main-text' style={{fontSize:"4rem"}}>
                <div>Why Choose </div>
                <div>Vizzhy?</div>
            </div>
            <div className='row w-100 '>
                <div className='col-md-6'>
                    <div className='fw-bold missionandvisiontextcolor fs-3 mt-4 mission-vison-sub-text'>Generative AI for Health</div>
                    <div className='fs-5 mt-3 mission-vison-para-text'>
                        Our generative AI model, 
                        built on over 1 billion health data points and capable 
                        of analyzing up to 350 GB of personal health data across 3 billion 
                        factors delivers personalized insights by assessing genes, metabolism, 
                        diet, stress, and sleep for proactive health management.ogical processes and disease mechanisms.</div>
                </div>
                <div className='col-md-6'>
                    <div className='fw-bold missionandvisiontextcolor fs-3 mt-4 mission-vison-sub-text'>P5 Medicine</div>
                    <div className='fs-5 mt-3 mission-vison-para-text'>Our approach is Predictive, Preventive, Precision, Participatory,
                         and Personalized, delivering care that evolves with you.</div>
                </div>
            </div>
            <div className='row w-100 mt-5'>
                <div className='col-md-6'>
                    <div className='fw-bold missionandvisiontextcolor fs-3 mission-vison-sub-text'>Multi-Omics Analysis</div>
                    <div className='fs-5 mt-3 mission-vison-para-text'>
                        We dive deep into the science of you! Our advanced multiomics analysis examines 
                        various layers of your biological data such as genes, proteins, microbes and metabolites 
                        to give a full picture of your health. This approach helps us to understand how your body
                         works and how could we personalize wellness solutions just for you.</div>
                </div>
                <div className='col-md-6'>
                    <div className='fw-bold missionandvisiontextcolor fs-3 mission-vison-sub-text'>IoT-Enabled Health Monitoring</div>
                    <div className='fs-5 mt-3 mission-vison-para-text'>Our IoT integration enables continuous real-time tracking of essential health metrics. 
                        Through wearable and connected devices, we monitor your health offering timely, 
                        actionable insights for a proactive, personalized approach to wellness.</div>
                </div>
            </div>
            </div>
            
        </div>
        </div>
        
    </div>
  )
}

export default WhyChooseVizzhy